export default __webpack_public_path__ + "static/media/twitter.ed7cc094.svg";